import { lazy } from 'react';

export function dynamicImport(componentImport, componentName) {
  return lazy(() =>
    componentImport().then(importedModule => ({ default: importedModule[componentName] }))
  );
}
